"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getElementPosition;
/* finds and returns a target elements x/y position relative to the document body */
/* must pass in an element reference */
function getElementPosition(elem) {
  let xPos = 0;
  let yPos = 0;
  while (elem) {
    if (elem.tagName === "BODY") {
      // deal with browser quirks with body/window/document and page scroll
      // let xScroll = elem.scrollLeft || document.documentElement.scrollLeft;
      // let yScroll = elem.scrollTop || document.documentElement.scrollTop;

      xPos += elem.offsetLeft + elem.clientLeft;
      yPos += elem.offsetTop + elem.clientTop;
    } else {
      // for all other non-BODY elements
      xPos += elem.offsetLeft - elem.scrollLeft + elem.clientLeft;
      yPos += elem.offsetTop - elem.scrollTop + elem.clientTop;
    }
    elem = elem.offsetParent;
  }
  return {
    x: xPos,
    y: yPos
  };
}